import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    popup:
      'absolute bottom-22 left-1/2 w-72 -translate-x-1/2 bg-white p-4 text-left shadow-[0px_0px_12px_0px_#3723091F]',
    info: 'bg-white px-3.5 py-6',
    title: 'mb-2 text-xl leading-[140%] font-medium',
    address: 'mb-1 text-xs leading-[140%]',
    phone:
      'border-b-bg-items-black border-b-1 text-xs leading-[140%] hover:opacity-70',
    button: 'mt-6 w-full',
    worktime: 'mb-3 text-xs leading-[140%]',
    stock: 'pt-4 font-medium'
  }
});
